import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function invalidAccountBuilder({parsedStatusObj}) {
  const broker = parsedStatusObj.brokerage;
  const accountNumber = parsedStatusObj.accountNumber;
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        No account for brokerage: {broker}. account: {accountNumber}.
      </Body3>
    </td>
  );
}
